import { AdjustmentType } from 'enums';

const InvoiceCategories = [
    AdjustmentType.Pricing,
    AdjustmentType.Quantity
];

export default InvoiceCategories;